import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {TransitLogItem} from '@portbase/bezoekschip-service-typescriptmodels';
import {VisitContext} from "../../../visit-details/visit-context";
import {ComparatorChain} from "../../../common/comparator-chain";
import {sendQuery} from "../../../common/utils";

@Component({
    selector: 'app-transit-history',
    templateUrl: './transit-history.component.html',
    styleUrls: ['./transit-history.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TransitHistoryComponent implements OnInit {

  context = VisitContext;
  items: TransitLogItem[] = [];
  reverseOrder = true;
  @Input() lrn: string;

  private logComparator = new ComparatorChain("timestamp").compare;

  ngOnInit(): void {
    sendQuery("com.portbase.bezoekschip.common.api.history.GetTransitLog", {lrn: this.lrn},
      {showSpinner: true, caching: false})
      .subscribe((items: TransitLogItem[]) => this.items = items.sort(this.logComparator));
  }

  cast = (item: TransitLogItem): TransitLogItem => item;

  toggleOrder() {
    this.reverseOrder = !this.reverseOrder;
  }
}
